import React, { FC } from "react";
import { Routes, Route } from "react-router-dom";
import { Role } from "common/Constants";
import ProtectedRoute from "common/ProtectedRoute";
import RoleEdit from "./RoleEdit";
import RolesList from "./RolesList";
import RoleUsers from "./RoleUsers";
import DispatchQueuesList from "./DispatchQueuesList";
import DispatchQueueEdit from "./DispatchQueueEdit";
import SuggestedEventsReport from "./SuggestedEventsReport";
import LookupTablesList from "./LookupTablesList";
import LeaseCompaniesAdmin from "./LeaseCompaniesAdmin";

export const AdminRouter: FC<{}> = () => (
  <Routes>
    <Route path="roles" element={<ProtectedRoute roles={[Role.Admin]}><RolesList /></ProtectedRoute>} />
    <Route path="role/:id" element={<RoleEdit />} />
    <Route path="role/:id/users" element={<ProtectedRoute roles={[Role.Admin]}><RoleUsers /></ProtectedRoute>} />
    <Route path="dispatch-queues" element={<ProtectedRoute roles={[Role.Admin]}><DispatchQueuesList /></ProtectedRoute>} />
    <Route path="dispatch-queue/:id" element={<ProtectedRoute roles={[Role.Admin]}><DispatchQueueEdit /></ProtectedRoute>} />
    <Route path="suggested-events" element={<ProtectedRoute roles={[Role.Admin]}><SuggestedEventsReport /></ProtectedRoute>} />
    <Route path="lookup-tables" element={<ProtectedRoute roles={[Role.Admin]}><LookupTablesList /></ProtectedRoute>} />
    <Route path="lookup-tables/lease-companies" element={<ProtectedRoute roles={[Role.Admin]}><LeaseCompaniesAdmin /></ProtectedRoute>} />
  </Routes>
);
